import { ShopTypes } from '~/lib/data-contract';
import { getGABasketItems } from '../utils/getGABasketItems';
import { pushToDataLayer } from '../utils/pushToDataLayer';
import { GAEcommerceEvent } from '../utils/types';

export function beginCheckout(basket?: ShopTypes.BasketResponse) {
    if (basket) {
        pushToDataLayer({ ecommerce: null });
        pushToDataLayer({
            event: GAEcommerceEvent.BeginCheckout,
            ecommerce: {
                currency: 'DKK',
                value: basket.total?.priceInclVat,
                items: getGABasketItems(basket.contexts),
                basketReference: basket.basketReference,
            },
        });
    }
}
